/* eslint-disable max-statements */
import { useMutation, useQuery } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import useToggle from "@bluframe/grapple/useToggle";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import { useHistory, useParams } from "react-router-dom";
import Item from "./Item";
const { forum: { GET_SECTIONS, GET_SECTION } } = queries;
const { forum: { DELETE_SECTION, UPDATE_SECTION } } = mutations;
const usePrepareComponent = () => {
    const [isEditing, toggleIsEditing] = useToggle();
    const history = useHistory();
    const params = useParams();
    const { data: sectionData, loading } = useQuery(GET_SECTION, {
        variables: {
            id: params.id
        }
    });
    const [updateSection] = useMutation(UPDATE_SECTION, {
        refetchQueries: [
            {
                query: GET_SECTION,
                variables: { id: params.id }
            }
        ]
    });
    const [deleteSection] = useMutation(DELETE_SECTION, {
        refetchQueries: [{ query: GET_SECTIONS }]
    });
    const onCancel = () => {
        history.push("/forum/sections");
    };
    const onEdit = () => {
        toggleIsEditing();
    };
    const onSave = (section) => {
        updateSection({
            onCompleted: () => {
                toggleIsEditing();
            },
            variables: {
                section: {
                    id: params.id,
                    section
                }
            }
        });
    };
    const onDelete = () => {
        deleteSection({
            onCompleted: () => {
                history.push("/forum/sections");
            },
            variables: {
                id: params.id
            }
        });
    };
    return {
        isEditing,
        item: sectionData?.section,
        loading,
        onCancel,
        onDelete,
        onEdit,
        onSave
    };
};
export default prepareComponent(usePrepareComponent)(Item);
